import React from 'react';

var __html = require('./termsandconditions.html');
var template = { __html: __html };

const Terms=()=>{
  return(
    <div style={{width:"100%",alignSelf:'flex-start',background:'white'}} dangerouslySetInnerHTML={template} />
  )
}
export default Terms;
